// extracted by mini-css-extract-plugin
export default {"badge":"StatusBadge_badge__bX8pZ","new":"StatusBadge_new__jGGIj","work":"StatusBadge_work__9dMTx","done":"StatusBadge_done__JHGuD","rej":"StatusBadge_rej__dDbWC"};